import React from "react";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import "../../styles/_review.scss";

const REVIEWS = [
  {
    name: "Sarah L.",
    avatar: "/review-1.png",
    quote:
      "OllaCart made my holiday shopping a breeze. I could see what my friends were shopping for and gave great gift ideas to my family. Love it!",
  },
  {
    name: "Mike T.",
    avatar: "/profile.svg",
    quote:
      "I love how I can add items from different stores and check out all at once. Plus, sharing my cart with friends is a game-changer.",
  },
  {
    name: "Jessica R.",
    avatar: "/review-3.png",
    quote:
      "The social aspect of Ollacart is fantastic. I can keep up with trends and get feedback on my choices before I buy.",
  },
];

const Stars = () => (
  <div className="star-section" aria-hidden="true">
    {Array.from({ length: 5 }).map((_, i) => (
      <span key={i} className="review-star">
        ★
      </span>
    ))}
  </div>
);

const ReviewCard = ({ review }) => (
  <article className="review-card">
    <div className="review-profile">
      <img
        src={review.avatar}
        alt=""
        width={40}
        height={40}
        loading="lazy"
        decoding="async"
      />
      <h3>{review.name}</h3>
    </div>
    <p>&quot;{review.quote}&quot;</p>
    <Stars />
  </article>
);

const Review = () => {
  const [ref, inView] = useInView({ triggerOnce: true });
  // Duplicate once for seamless loop (not 3×)
  const loop = [...REVIEWS, ...REVIEWS];

  return (
    <motion.section
      id="review-container"
      ref={ref}
      initial={{ opacity: 0, y: 40 }}
      animate={{ opacity: inView ? 1 : 0, y: inView ? 0 : 40 }}
      transition={{ duration: 0.6, ease: "easeOut" }}
    >
      <div className="review-content">
        <h2>
          From people who <span>shop with friends</span>
        </h2>
        <p>
          Real shoppers using one cart for a cleaner buy, and sharing when they
          want a second opinion.
        </p>
      </div>

      <div className="review-marquee" aria-label="Customer reviews">
        <div className="review-marquee__track">
          {loop.map((review, i) => (
            <ReviewCard key={`${review.name}-${i}`} review={review} />
          ))}
        </div>
      </div>
    </motion.section>
  );
};

export default Review;
